import type { SupabaseClient } from '@supabase/supabase-js'

export interface OrgPaymentConnectionStatus {
  readonly status: 'active' | 'disabled' | null
  readonly providerUserId: string | null
  readonly updatedAt: string | null
}

export async function getOrgPaymentConnectionStatus(
  client: SupabaseClient,
  organizationId: string,
  provider = 'mercadopago',
): Promise<OrgPaymentConnectionStatus> {
  const { data, error } = await client
    .rpc('get_org_payment_connection_status', { p_organization_id: organizationId, p_provider: provider })
    .maybeSingle()
  if (error) throw error

  const row = data as { status: string; provider_user_id: string | null; updated_at: string } | null

  return {
    status: (row?.status as OrgPaymentConnectionStatus['status']) ?? null,
    providerUserId: row?.provider_user_id ?? null,
    updatedAt: row?.updated_at ?? null,
  }
}

export async function startMercadoPagoOAuth(client: SupabaseClient, organizationId: string): Promise<string> {
  const { data, error } = await client.functions.invoke('mercadopago-oauth-start', {
    body: { organizationId },
  })
  if (error) throw error

  const authorizeUrl = (data as { authorizeUrl?: string } | null)?.authorizeUrl
  if (!authorizeUrl) throw new Error('No se pudo iniciar la conexion con Mercado Pago.')
  return authorizeUrl
}
